import { useEffect, useState } from "react";
import { ChevronDown, ChevronUp, CheckCircle2 } from "lucide-react";
import VCheckField from "./VCheckField";
import VCheckPhotoBlock from "./VCheckPhotoBlock";

export function showIfMatches(cond, data) {
  if (!cond) return true;
  const v = data?.[cond.field];
  if ("equals" in cond) return v === cond.equals;
  if ("gte" in cond) return v !== null && v !== undefined && v !== "" && Number(v) >= Number(cond.gte);
  return true;
}

export default function VCheckSection({ section, data, photos, projectId, onChange, onPhotosChanged, missingKeys, missingPhotos, defaultOpen }) {
  const [open, setOpen] = useState(defaultOpen);
  // Iter88zv-fix — Section-Open-State darf NICHT durch parent-Re-Render zurückgesetzt werden.
  useEffect(() => { /* state stays local */ }, []);
  const visibleFields = section.fields.filter((f) => showIfMatches(f.show_if, data));
  const dataFields = visibleFields.filter((f) => f.type !== "photo_block" && f.type !== "signature");
  const filledReq = dataFields.filter((f) => f.required).filter((f) => !missingKeys.includes(f.key)).length;
  const totalReq = dataFields.filter((f) => f.required).length;
  const photoBlocksHere = visibleFields.filter((f) => f.type === "photo_block");
  const done = filledReq === totalReq && !photoBlocksHere.some((f) => f.required && missingPhotos.includes(f.key));

  return (
    <div className={`rounded-xl border ${done ? "border-emerald-500/40 bg-emerald-500/[0.03]" : "border-zinc-800 bg-zinc-950"}`}
         data-testid={`vcheck-section-${section.section}`}>
      <button type="button" onClick={() => setOpen(!open)} className="w-full flex items-center justify-between px-4 py-3">
        <div className="flex items-center gap-3">
          <div className={`w-8 h-8 rounded-lg flex items-center justify-center text-[13px] font-bold ${
            done ? "bg-emerald-500 text-zinc-950" : "bg-zinc-800 text-zinc-300"
          }`}>
            {done ? <CheckCircle2 size={16} /> : section.section}
          </div>
          <div className="text-left">
            <div className="text-[14px] font-semibold text-zinc-100">{section.title}</div>
            {totalReq > 0 && (
              <div className="text-[11px] text-zinc-500 font-mono">{filledReq}/{totalReq} Pflichtfelder</div>
            )}
          </div>
        </div>
        {open ? <ChevronUp size={16} className="text-zinc-500" /> : <ChevronDown size={16} className="text-zinc-500" />}
      </button>
      {open && (
        <div className="px-4 pb-4 space-y-3 border-t border-zinc-800 pt-3">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {dataFields.map((f) => (
              <div key={f.key} className={f.type === "textarea" || f.type === "multiselect" ? "md:col-span-2" : ""}>
                <label className="text-[11px] text-zinc-400 flex items-center gap-1 mb-1">
                  {f.label}
                  {f.required && <span className="text-yellow-500">*</span>}
                  {f.unit && f.type !== "number" && <span className="text-zinc-500">({f.unit})</span>}
                </label>
                <VCheckField field={f} value={data[f.key]} onChange={(v) => onChange(f.key, v)}
                             missing={f.required && missingKeys.includes(f.key)} />
              </div>
            ))}
          </div>
          {photoBlocksHere.map((f) => (
            <VCheckPhotoBlock key={f.key} field={f} photos={photos[f.key]} projectId={projectId}
                              onChanged={onPhotosChanged}
                              missing={f.required && missingPhotos.includes(f.key)} />
          ))}
        </div>
      )}
    </div>
  );
}
